import React, { useEffect, useMemo, useState } from "react";
import styles from "./syllabus.module.css";
import {
    CustomButton,
    CustomDropdown,
    CustomTextInput,
} from "../../../../components";
import AxiosInstance, { TokenService } from "../../../../services/Api";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaPlus } from "react-icons/fa";

function ViewStaffSyllabus() {
    const navigate = useNavigate();
    const location = useLocation();
    const { SECTION, SYLLABUSID } = location.state || {};

    const { translations } = useSelector((state) => state.language);
    const user = TokenService.getUser();
    const userId = user?.id || 0;
    const client_id = user?.client_data[0].client_id || "";
    const clientData = user?.client_data[0] || [];
    const school_id = clientData?.school_id || "";
    const academic_year = clientData?.academic_year || "";
    const academic_id = clientData?.academic_year_id || "";

    const [formData, setFormData] = useState({
        class_name: "",
        class_id: "",
        section: SECTION || "",
        subject_name: "",
        chapter: "",
        units: "",
        short_description: "",
        description: "",
        page_to: "",
        page_from: "",
        progressStatus: ""
    });

    const [data, setData] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const progressData = [
        { label: "Pending", value: 1 },
        { label: "Ongoing", value: 2 },
        { label: "Completed", value: 3 },
    ];


    useEffect(() => {
        fetchViewSyllabus();
    }, [SYLLABUSID]);
    const fetchViewSyllabus = async () => {
        setLoading(true);
        try {
            const response = await AxiosInstance.post("/school/viewSyllabus", {
                id: SYLLABUSID,
            });

            if (response?.data?.status) {
                const Data = response.data.data;

                const normalizedData = (Array.isArray(Data) ? Data : [Data]).map(
                    (row) => ({
                        ...row,
                        exam_plan: row.exam_plan ? Number(row.exam_plan) : "", // ✅ FIX
                    }),
                );
                setFormData(Data);
                setData(normalizedData);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching subject list", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleDropdownChange = (name, option) => {
        setFormData((prev) => ({ ...prev, [name]: option }));
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.progressStatus)
            newErrors.progressStatus = translations.errors.progressRequired || "Progress status is required";
        return newErrors;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;
        const payload = {
            client_id: client_id,
            school_id: school_id,
            academic_id: academic_id,
            class_id: formData.class_id,
            section_id: SECTION,
            staff_id: userId,
            syllabus_id: SYLLABUSID,
            status: formData.progressStatus?.value
        };

        try {
            const response = await AxiosInstance.put(
                `/school/updateSyllabusStatus`,
                payload,
            );
            if (response.data.status) {
                navigate("/user/syllabus");
            } else {
                throw new Error(response.data?.message || "Message send failed");
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleCancel = () => {
        navigate(-1)
        setFormData({});
    };
    return (
        <div className={styles.container}>
            <form onSubmit={handleSubmit} className="row g-4">
                {/* Class */}

                <div className="col-md-4 px-2">
                    {/* Subject */}
                    <CustomDropdown
                        label={translations.labels.class}
                        name="class"
                        value={formData.class_name}
                        options={data}
                        placeholder={translations.labels.classPlaceholder}
                        disabled
                    />
                </div>
                <div className="col-md-4 px-2">
                    {/* Subject */}
                    <CustomDropdown
                        label={translations.labels.section}
                        name="section"
                        value={SECTION}
                        options={data}
                        placeholder={translations.labels.sectionPlaceholder}
                        disabled
                    />
                </div>
                <div className="col-md-4 px-2">
                    {/* Subject */}
                    <CustomDropdown
                        label={translations.labels.subject}
                        name="subject"
                        value={formData.subject_name}
                        options={data}
                        placeholder={translations.labels.subjectPlaceholder}
                        disabled
                    />
                </div>



                {/* Chapter */}
                <div className="col-md-4 px-2">
                    <CustomTextInput
                        label={translations.labels.chapter}
                        type="number"
                        name="chapter"
                        value={formData.chapter}
                        placeholder={translations.labels.subjectPlaceholder}
                        disabled
                    />
                </div>
                {/* Units */}
                <div className="col-md-4 px-2">
                    <CustomTextInput
                        label={translations.labels.unit}
                        name="units"
                        value={formData.units}
                        disabled
                        placeholder={translations.labels.subjectPlaceholder}

                    />
                </div>
                {/* Page From */}
                <div className="col-md-4 px-2">
                    <CustomTextInput
                        label={translations.labels.pages || "Pages"}
                        type="text"
                        name="pages"
                        value={`${formData.page_from}-${formData.page_to}`}
                        disabled
                        placeholder="E.g.1"
                    />
                </div>
                {/* Short Description */}
                <div className="col-md-4 px-2">
                    <CustomTextInput
                        label={translations.labels.shortDescription}
                        name="short_description"
                        multiline
                        rows={3}
                        value={formData.short_description}
                        disabled
                        placeholder={translations.labels.shortDescriptionPlaceholder}
                    />
                </div>
                {/* Description */}
                <div className="col-md-4 px-2">
                    <CustomTextInput
                        label={translations.labels.description}
                        name="description"
                        multiline
                        rows={3}
                        className={styles.TextAreaStyles}
                        value={formData.description}
                        placeholder={translations.labels.descriptionPlaceholder}
                        disabled
                    />
                </div>
                <div className="col-md-4 px-2">
                    {/* Subject */}
                    <CustomDropdown
                        label={translations.labels.progressStatus || "Progress Status"}
                        name="progressStatus"
                        value={formData.progressStatus}
                        onChange={(option) => handleDropdownChange("progressStatus", option)}
                        options={progressData}
                        placeholder={translations.labels.ProgressStatusPlaceholder || "Select progress status "}
                        required
                        error={errors.progressStatus}
                    />
                </div>

                <div className="col-md-12">
                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <CustomButton
                            variant="contained"
                            onClick={handleSubmit}
                            className={styles.saveButton}
                            fullWidth={false}
                            loading={loading}
                        >
                            {translations.labels.saveButton}
                        </CustomButton>

                        <CustomButton
                            variant="contained"
                            onClick={handleCancel}
                            className={styles.cancelButton}
                            fullWidth={false}
                            disabled={loading}
                        >
                            CANCEL
                        </CustomButton>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default ViewStaffSyllabus;
